import { getABTestsConfig } from "../../actions/Page/utils";
import { getPersonalizedItems } from "../../fetch/graphql/requests/mlDrivenItems/library";
import { getUserFromCookie } from "../../utils/cookies/library";

/** WEBX-3068-A/B Test For For You Filter on Vertical Video */
export const personalizationABTest = async (variant) => {
    const user = getUserFromCookie();
    const userId = user?.id;

    if (!userId) {
        return Promise.reject([]);
    }

    const abTestConfigs = await getABTestsConfig();
    const vvConfig = abTestConfigs["homepage-vertical-video-for-you"];
    const algorithmId = vvConfig.variants[variant]?.algorithmId;

    const response = await getPersonalizedItems(algorithmId, userId, 10);

    return response?.data?.personalizedItems?.nodes || [];
};
